<ng-container *ngIf="formData && formData.get(descriptionField)">
  <app-mu-modal-dialog-layout
    [title]="title || ('page.delivery.orders.cancel.title' | translate)"
    [icon]="'fa-times'"
    [flagList]="flagList"
    [showFlag]="showFlag"
    [actionFlag]="actionFlag"
    [loaderFlag]="loaderFlag"
    [formData]="formData"
    [showCloseIcon]="showCloseIcon"
    [buttonCancelLabel]="hideCancel ? '' : cancelLabel"
    [buttonMainActionLabel]="actionLabel || 'page.delivery.orders.cancel.send'"
    class="mu-modal-cancel"
  >
    <div class="p-grid p-justify-center p-align-center" *ngIf="getShowModalState()" modalDialogContent>
      <p
        class="p-col-12 mu-modal-text mu-without-padding"
        [innerHTML]="contentModalInnerHtml ? contentModalInnerHtml:
          'page.delivery.orders.cancel.' + cancellationKey
            | translate: { link: cancellationLink, value: utils.formatCurrency(cancellationValue, country) }
        "
      ></p>
      <form class="p-col-12 mu-without-padding" [formGroup]="formData" appValidator *ngIf="getShowModalState()">
        <div class="p-grid p-justify-center">
          <div class="p-col-12 p-field mu-without-padding" *ngIf="cancellationTypeList && cancellationTypeList.length > 0">
            <p-dropdown
              [options]="cancellationTypeList"
              id="cancellationType"
              name="cancellationType"
              appendTo="body"
              [placeholder]="'page.delivery.orders.cancel.cancellationType.0' | translate"
              formControlName="cancellationType"
              (onShow)="validatorService?.scrollToSelected(changeDetectorRef, formData, 'cancellationType', cancellationTypeList)"
            >
              <ng-template let-cancellationType pTemplate="item">
                <span translate>page.delivery.orders.cancel.cancellationType.{{ cancellationType?.value }}</span>
              </ng-template>
              <ng-template let-cancellationType pTemplate="selectedItem">
                <span *ngIf="cancellationType?.value">{{ 'page.delivery.orders.cancel.cancellationType.' + cancellationType?.value | translate }}</span>
              </ng-template>
            </p-dropdown>
          </div>
          <div
            class="p-field p-col-12 mu-modal-textarea"
            [ngClass]="{ 'mu-display-none': !['4', '8'].includes(formData?.get('cancellationType').value + '') }"
          >
            <textarea
              pInputTextarea
              id="description"
              name="description"
              formControlName="description"
              maxlength="300"
              minlength="3"
              [placeholder]="'page.delivery.orders.cancel.descriptionPlaceholder' | translate"
            ></textarea>
          </div>
        </div>
      </form>
    </div>
  </app-mu-modal-dialog-layout>
</ng-container>
